import { AppStrings } from "../../../utils/constants/AppStrings";

/**
 * Built per call so TCM strings that arrive after boot (and language switches)
 * are picked up. Module-scope `AppStrings.X` snapshots freeze English defaults
 * before `loadAppStringsForLanguage` / `setAppString` rebind AppStrings.
 */
const conditionTypeKeyLabels = (): Readonly<Record<string, string>> => ({
  min_event_amount: AppStrings.PAM_DYNAMIC_BONUS_CONDITION_MIN_EVENT_AMOUNT,
  min_cumulative_deposits:
    AppStrings.PAM_DYNAMIC_BONUS_CONDITION_MIN_CUMULATIVE_DEPOSITS,
  is_first_deposit: AppStrings.PAM_DYNAMIC_BONUS_CONDITION_IS_FIRST_DEPOSIT,
  user_was_referred: AppStrings.PAM_DYNAMIC_BONUS_CONDITION_USER_WAS_REFERRED,
  event_field_equals: AppStrings.PAM_DYNAMIC_BONUS_CONDITION_EVENT_FIELD_EQUALS,
  event_field_compare: AppStrings.PAM_DYNAMIC_BONUS_CONDITION_EVENT_FIELD_COMPARE,
  feature_flag_enabled:
    AppStrings.PAM_DYNAMIC_BONUS_CONDITION_FEATURE_FLAG_ENABLED,
  not_already_awarded: AppStrings.PAM_DYNAMIC_BONUS_CONDITION_NOT_ALREADY_AWARDED,
  max_awards_per_user: AppStrings.PAM_DYNAMIC_BONUS_CONDITION_MAX_AWARDS_PER_USER,
  cooldown_since_last_award:
    AppStrings.PAM_DYNAMIC_BONUS_CONDITION_COOLDOWN_SINCE_LAST_AWARD,
  user_attribute_equals:
    AppStrings.PAM_DYNAMIC_BONUS_CONDITION_USER_ATTRIBUTE_EQUALS,
  user_not_excluded: AppStrings.PAM_DYNAMIC_BONUS_CONDITION_USER_NOT_EXCLUDED,
  user_in_segment: AppStrings.PAM_DYNAMIC_BONUS_CONDITION_USER_IN_SEGMENT,
  referral_code_is_affiliate:
    AppStrings.PAM_DYNAMIC_BONUS_CONDITION_REFERRAL_CODE_IS_AFFILIATE,
  campaign_affiliate_code_matches:
    AppStrings.PAM_DYNAMIC_BONUS_CONDITION_CAMPAIGN_AFFILIATE_CODE_MATCHES,
  user_subscribed: AppStrings.PAM_DYNAMIC_BONUS_CONDITION_USER_SUBSCRIBED,
  applied_offer_matches:
    AppStrings.PAM_DYNAMIC_BONUS_CONDITION_APPLIED_OFFER_MATCHES,
});

/** Always-on NL label for condition pickers, badges, and detail cards. */
export const conditionDisplayLabel = (typeKey: string): string =>
  conditionTypeKeyLabels()[typeKey] ?? typeKey;
